import { useMutation, useQuery } from 'react-query';
import queryGetMerchantUsers from './queries/getMerchantUsers';
import mutationCreateMerchantUser from './mutations/createMerchantUser';
import queryGetMerchantUserProfiles from './queries/getMerchantUserProfiles';
import mutationResetUsersPassword from './mutations/resetUsersPassword';

const actionsMerchantUsers = {
    // Getters
    getMerchantUsers: (params, enabled) => useQuery(queryGetMerchantUsers(params, enabled)),
    getMerchantUserProfiles: (organizationId) => useQuery(queryGetMerchantUserProfiles(organizationId)),

    // Mutations
    // Merchant User creation
    createMerchantUser: (onSuccess, onError) => useMutation(mutationCreateMerchantUser(onSuccess, onError)),
    // Reset users password after merchant account creation by CSV
    resetUsersPassword: (onSuccess, onError) => useMutation(mutationResetUsersPassword(onSuccess, onError))
};

export default actionsMerchantUsers;